<div class="full-width" [formGroup]="myForm">
    <div class="btn-group mr-2 full-width"
         role="group"
         aria-label="First group">
        <button class="no-border pl-0 full-width"
                title="Izaberi projekat"
                [disabled]="isDisabled"
                [matMenuTriggerFor]="projectMenu"
                required
                mat-stroked-button>
            <mat-icon class="work">work</mat-icon>
            {{buttonText}}
        </button>
        <button
                class="btn shadow-none"
                type="button"
                [disabled]="addButtonDisabled==true || isDisabled"
                *ngIf="isSelected===true"
                (click)="setProject(null);">
            <mat-icon class="sp-work">
                close
            </mat-icon>
        </button>

<!--      Opcija za dodavanje novog projekta prilikom kreiranja zadatka-->

<!--        <button-->
<!--                class="btn shadow-none"-->
<!--                type="button"-->
<!--                [disabled]="addButtonDisabled==true"-->
<!--                *ngIf="isSelected===false"-->
<!--                (click)="addNewProjectDialog()">-->
<!--            <mat-icon class="sp-work">add</mat-icon>-->
<!--        </button>-->
    </div>
    <div style="font-size: 80%;color: #dc3545"
         *ngIf="myForm.get('taskProject').invalid && myForm.get('taskProject').touched">
        Ovo polje je obavezno.
    </div>
</div>


<mat-menu [overlapTrigger]="false"
          #projectMenu="matMenu">
    <div class="sp-pl-15"
         (click)="$event.stopPropagation()">
        <input class="form-control sp-form-control-placeholdericon"
               placeholder="&#xe8b6; Pretraži"
               type="text"
               (keyup)="filterProjects($event)"
               [(ngModel)]="searchText">
    </div>
    <div>
        <section class="sp-section">
            <span class="example-list-section">
    <ul class="sp-pl-15">
      <li *ngFor="let project of filteredProjects">
        <section class="sp-select">
  <mat-option class="full-width"
              (onSelectionChange)="buttonText=project.name;setProject(project)">
      {{project.name}}
  </mat-option>
</section>
      </li>
    </ul>
  </span>
        </section>
    </div>
</mat-menu>





